import { getPhotoSdk } from "./photo"

export const getFamilySdk = () => {
  const sdk = getPhotoSdk()
  const family = sdk.family

  return family
}